import type { MomentMessageType } from "../../data/momentOptions";
import { SectionBox } from "../shared";

type Props = {
  messageType: MomentMessageType;
  shareFlag: boolean;
  onShareFlagChange: (val: boolean) => void;
};

export default function ShareSection({ messageType, shareFlag, onShareFlagChange }: Props) {
  return (
    <SectionBox label="공유하기" enabled={shareFlag} onToggle={onShareFlagChange}>
      {messageType === "BASIC_TEXT_MESSAGE" && (
        <p className="tw-text-xs tw-text-gray-500">
          카드 오른쪽에 공유하기 버튼이 추가됩니다.
        </p>
      )}
    </SectionBox>
  );
}
